module.exports = __webpack_public_path__ + "img/check-green.ca1e02b7.svg";